"use client";

import { FilterCategoryHeader } from './filter-category-header';
import { FilterOption } from './filter-option';
import { FilterItem } from '@/lib/services/catalog/catalog-types';

interface FilterCategoryProps {
  title: string;
  categoryKey: string;
  items: FilterItem[];
  selectedValues: string[];
  onFilterChange: (category: string, value: string) => void;
  onResetCategory: (category: string) => void;
  isLastCategory?: boolean;
}

export function FilterCategory({
  title,
  categoryKey,
  items,
  selectedValues,
  onFilterChange,
  onResetCategory,
  isLastCategory: _isLastCategory = false
}: FilterCategoryProps) {
  return (
    <div>
      <FilterCategoryHeader 
        title={title} 
        categoryKey={categoryKey} 
        onReset={onResetCategory} 
        selectionCount={selectedValues.length}
      />
      <div className="space-y-1">
        {items.map((item, index) => (
          <div 
            key={item.value}
            className="animate-fade-in"
            style={{ animationDelay: `${index * 30}ms` }}
          >
            <FilterOption 
              value={item.value}
              label={item.label}
              suffix={item.suffix}
              isSelected={selectedValues.includes(item.value)}
              categoryKey={categoryKey}
              onChange={onFilterChange}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
